/**
 * fileExtension
 *
 * Get the file extension for the given filename.
 *
 * @param {String} filename The filename to get the extension for.
 * @returns {String} The file extension.
 * @export
 */
export default function(filename) {
  return filename.split('.').pop();
}



// WEBPACK FOOTER //
// ./src/utils/file-extension.js